/**
 * openRowGuard.js
 *
 * RN117.0 (story #150): a row is open exactly when the second argument of the generic table's
 * `onEditIndexChanged(editIndex, row)` is truthy — adding a row reports `(-1, newElement)`, editing one
 * reports `(index, row)`, and closing reports `(-2)` with no row at all. The index alone cannot tell
 * those apart.
 *
 * RN117.3: what the save guard needs is the SET of hosts that currently hold an open row, not a
 * boolean. Three screens mount task and resource tables at once, and with a single flag the host that
 * closed last would clear the flag another host still needs raised, unblocking a save that must stay
 * blocked. RN117.3.1: the set holds identifiers only — it never needs to know what is being edited.
 *
 * RN117.3.2: a host that unmounts while its row is open leaves the set through the same door it came
 * in. Otherwise the process would be impossible to save with nothing on screen to explain why, which is
 * worse than the defect this guard exists to fix.
 */

/** RN117.0 — the row the table reports, not the index, is what says whether one is open. */
const isRowOpen = (row) => !!row

/**
 * RN117.3 — adds or removes one host without disturbing the others. Returns a new set so React sees
 * the change.
 */
const withHostOpenState = (openHosts, hostId, isOpen) => {
  const next = new Set(openHosts)
  if (isOpen) {
    next.add(hostId)
  } else {
    next.delete(hostId)
  }
  return next
}

/** RN117.1 — the save is blocked while ANY host holds an open row. */
const hasAnyOpenRow = (openHosts) => openHosts.size > 0

export { isRowOpen, withHostOpenState, hasAnyOpenRow }
